const HeroPromoBannerBlock = (() => {
    function heroPromoMobileClass() {
        // Body class to manipulate promo-disclaimer position on mobile and tablets
        if ($('.promo-disclaimer').length > 0) {
            $('body').addClass('has-hero-promo-disclaimer');
        }
    }

    return {
        init() {
            heroPromoMobileClass();
        },
    };
})();

export default (() => {
    $(document).ready(HeroPromoBannerBlock.init);
})();
